import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';

import { Button, Modal, Spacer, Textarea, Radios } from '@ontruck/orc';
import * as http from 'utils/http';
import config from 'config';

import { searchVehicles } from 'redux/modules/vehicle-section/effects';

const t = {
  call_status: 'Call status',
  block: 'Block',
  call_later: 'Call later',
  set_carrier_status: 'Set carrier call status',
  save: 'Save',
  comment: 'Comment',
};

const CarrierCallStatusModal = ({ carrierId, onClose, location }) => {
  const [status, setStatus] = useState(null);
  const [comment, setComment] = useState('');
  const [postData, setPostData] = useState(null);
  const [posting, setPosting] = useState(false);
  const dispatch = useDispatch();

  const onChangeStatus = useCallback((e, { name, value }) => setStatus(value), []);

  const onChangeComment = useCallback((e, { value }) => {
    setComment(value);
  }, []);

  useEffect(() => {
    const postCarrierCallStatus = async (postData) => {
      try {
        await http.post(config.API_URL + `fleet/callstatus/`, postData);
        setPosting(false);
        const qs = queryString.parse(location.search);
        dispatch(searchVehicles(qs));
        onClose();
      } catch (err) {
        setPosting(false);
        onClose();
      }
    };
    if (postData) {
      postCarrierCallStatus(postData);
    }
  }, [dispatch, onClose, postData, location]);

  const handleSubmit = useCallback(
    (statusData) => {
      setPostData({ status: status, comment: comment, carrier: carrierId });
    },
    [carrierId, comment, status]
  );

  return (
    <Modal show visibleOverflow onClose={onClose} headerComponent={t.set_carrier_status}>
      <Radios
        girded
        size="M"
        legend={t.call_status}
        name={'call_status'}
        items={[
          { value: 'BLOCK', label: t.block },
          { value: 'LATER', label: t.call_later },
        ]}
        onChange={onChangeStatus}
      />
      <Spacer mTop="S">
        <Textarea
          fullWidth
          label={t.comment}
          value={comment}
          onChange={onChangeComment}
          height={'100px'}
          width={'100%'}
        />
      </Spacer>
      <Spacer mTop="S">
        <Button text={t.save} disabled={!status || posting} fullWidth onClick={handleSubmit} />
      </Spacer>
    </Modal>
  );
};

export default withRouter(CarrierCallStatusModal);
